import { render, staticRenderFns } from "./productCodeItem.vue?vue&type=template&id=c407846a&scoped=true&"
import script from "./productCodeItem.vue?vue&type=script&lang=js&"
export * from "./productCodeItem.vue?vue&type=script&lang=js&"
import style0 from "./productCodeItem.vue?vue&type=style&index=0&id=c407846a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c407846a",
  null
  
)

export default component.exports